import LaporanPenawaran from './LaporanPenawaran';

export default LaporanPenawaran;
